export default {
  id: 19,
  title: 'Target #19 - Cube',
  url: 'https://cssbattle.dev/play/19',
  colors: ['#0B2429', '#F3AC3C', '#998235', '#1A4341'],
  solution:
    '<a a><a b><a c><style>body{background:#0b2429}a{position:fixed}a[a],a[b]{top:80;width:70;height:70}a[a]{left:130;background:#998235;transform:skewY(-45deg)}a[b]{left:200;background:#1a4341;transform:skewY(45deg)}a[c]{top:135;left:150;background:#f3ac3c;width:100;height:100;transform:rotate(45deg)}</style>',
}
